import { getFallbackConfig } from "./config";
import type { InterviewFallbackProps } from "./types";
import AfterInterview from "../afterInterview/AfterInterview";
import { Button } from "@cointervue/design-system";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";

export function InterviewFallbackScreen({
  variant,
  role = "candidate",
  customMessage,
}: InterviewFallbackProps) {
  const navigate = useNavigate();
  const { token } = useParams();
  const isPanelist = role === "panel";
  const { title, description, icon, iconColor, iconBgColor, nextSteps } =
    getFallbackConfig(variant, role);

  const handleResume = useCallback(() => {
    navigate(`/i/${token}/interviewRoom`);
  }, [navigate, token]);

  return (
    <div className="auth-page">
      <AfterInterview
        title={title}
        description={customMessage || description}
        icon={icon}
        iconColor={iconColor}
        iconBgColor={iconBgColor}
        showFeedback={false}
        showNextSteps={!!nextSteps && nextSteps.length > 0}
        nextSteps={nextSteps}
        isPanelist={isPanelist}
      >
        {variant === "rejoin" && (
          <Button
            className="w-full rounded-full mt-4"
            variant="interviewPrimaryAction"
            onClick={handleResume}
          >
            {isPanelist ? "Join Interview Room" : "Resume Interview"}
          </Button>
        )}
      </AfterInterview>
    </div>
  );
}

